import DynamicFormChoiceModelBase from '../_generated/modelBases/dynamic-form-choice-model-base';

export default class DynamicFormChoiceModel extends DynamicFormChoiceModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
